const initializeFlashFade = () => {
  setTimeout(() => {
    $(".js-flash-message").fadeOut("slow");
  }, 60000);
};

export default initializeFlashFade;
